import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  IconButton,
  Tab,
  Tabs,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import TabPanel from '../../components/TabPanel';

function InsurancesViewModal(props) {
  const {
    open,
    onClose,
    provider,
    classes: { modal, modalContent, items, closeButton },
  } = props;
  return (
    <Dialog fullWidth open={open} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <Grid item xs={12} className={closeButton}>
          <IconButton aria-label="Close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Accepted Insurances" />
          </Tabs>

          <TabPanel>
            <Grid className={items} item xs={12}>
              <ul>
                {provider.insurances.map(row => (
                  <li>{row.name}</li>
                ))}
              </ul>
            </Grid>
          </TabPanel>
        </AppBar>
      </DialogContent>
    </Dialog>
  );
}

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  items: {
    marginLeft: '2em',
  },
  closeButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

InsurancesViewModal.propTypes = {
  request: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(InsurancesViewModal);
